/**
 * Owner: Masa Bayu
 * File: bka-wave-a-types.ts
 * Date:Time: 2026-09-22 17:01
 * Description: BKA book-create types — blank|manuscript|pdf · overlay · proposalId.
 */
/** Feature flag scaffolding — default OFF in production (R12). */
export const BKA_WAVE_A_FEATURE_FLAG = Object.freeze({
    id: 'bka.wave_a.blank',
    defaultEnabledInProduction: false,
    wave: 'A',
    path: 'blank',
});
export const BKA_CREATION_MODES = ['blank', 'manuscript', 'pdf'];
/** Wave A Blank path (retained). */
export const BKA_WAVE_A_AUTHORIZED_MODE = 'blank';
/** Modes authorized for AddBook (PDF authorized under PDF BUILD AUTH). */
export const BKA_AUTHORIZED_CREATION_MODES = Object.freeze([
    'blank',
    'manuscript',
    'pdf',
]);
export const BKA_AUTHORING_SUBSTATES = [
    'draft_open',
    'source_pending',
    'source_bound',
    'source_failed',
    'proposal_pending',
    'author_review',
    'qxw_sot_ready',
];
export const BKA_ERROR_CLASSES = [
    'AUTH',
    'CONFLICT',
    'FAILED_PRECONDITION',
    'INTEGRATION',
    'VALIDATION',
    'NOT_FOUND',
];
export function bkaFail(errorClass, code, reason) {
    return Object.freeze({
        ok: false,
        errorClass,
        code,
        reason,
        originalPreserved: true,
        mutatesQxw: false,
        mutatesQxp: false,
    });
}
export const BKA_QXW_SOT_PREDICATES = [
    'P1',
    'P2',
    'P3',
    'P4',
    'P5',
    'P6',
    'P7',
    'P8',
];
//# sourceMappingURL=bka-wave-a-types.js.map